// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════════════════════════════════
   Seller and admin portals

   These are the two surfaces built most explicitly for a desktop: a
   persistent left sidebar of 14 nav items, page heads that put a title and
   two buttons on one line, and analytics laid out for a 1400px canvas.

   The data and every action are kept. What changes is that the portal stops
   pretending it has a second column and a wide viewport.
   ════════════════════════════════════════════════════════════════════════ */

/* ── Portal app bar ─────────────────────────────────────────────────────
   .sp-topbar is the portal's own header. It gets the same geometry as the
   storefront's app bar so moving between the two doesn't feel like moving
   between two apps. */
html.m-app .sp-topbar {
  position: sticky;
  top: 0;
  z-index: 120;
  gap: var(--m-1);
  min-height: var(--m-appbar);
  padding: 0 var(--m-2);
  padding-top: var(--m-safe-top);
  background: var(--m-surface-bar);
  border-bottom: 1px solid var(--m-hairline);
  box-shadow: none;
}

html.m-app .sp-topbar-title {
  font-size: 1.0625rem;
  font-weight: var(--m-fw-semibold);
  letter-spacing: var(--m-track-title);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

html.m-app .sp-topbar-right {
  gap: 0;
}

html.m-app .sp-topbar button {
  min-width: var(--m-touch);
  min-height: var(--m-touch);
  border-radius: var(--m-r-pill);
}

/* ── Page head ──────────────────────────────────────────────────────────
   The app bar already names the screen, so the page title repeating it
   ("Dashboard" twice, one above the other) is pure duplication. The title
   goes; the subtitle stays, since "Welcome back, <name>" is the only place
   the portal greets its user. */
html.m-app .sp-page {
  padding: var(--m-4) var(--m-gutter) calc(var(--m-8) + var(--m-safe-bottom));
}

html.m-app .sp-page-head {
  flex-direction: column;
  align-items: stretch;
  gap: var(--m-3);
  margin-bottom: var(--m-4);
}

html.m-app .sp-page-title {
  display: none;
}

html.m-app .sp-page-sub {
  font-size: var(--m-fs-secondary);
  line-height: var(--m-lh-snug);
  color: var(--color-text-secondary);
  margin: 0;
}

/* Head actions: one primary, the rest secondary. "Export" and "+ Add
   Product" were two filled buttons of equal weight side by side. */
html.m-app .sp-page-head-right {
  display: flex;
  gap: var(--m-2);
  width: 100%;
}

html.m-app .sp-page-head-right > * {
  flex: 1 1;
  min-height: var(--m-touch);
  font-size: var(--m-fs-secondary);
  white-space: nowrap;
}

/* ── Order pipeline ─────────────────────────────────────────────────────
   Seven stages, each a 170px-tall card with a 40px icon disc and a
   sparkline, wrapped into a 2-column grid — about three screens of
   scrolling for seven numbers. It becomes one swipeable rail of compact
   stages, which is also closer to what a pipeline *is*: an ordered
   sequence you read left to right.

   The connecting "›" arrows are dropped: with the stages scrolling they
   no longer line up, and the horizontal order already implies the flow. */
html.m-app .sp-pipeline {
  display: flex;
  flex-wrap: nowrap;
  gap: var(--m-2);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x proximity;
  scrollbar-width: none;
  margin: 0 calc(var(--m-4) * -1);
  padding: var(--m-1) var(--m-4);
}

html.m-app .sp-pipeline::-webkit-scrollbar { display: none; }

html.m-app .sp-pipeline-step {
  flex: 0 0 auto;
  scroll-snap-align: start;
}

html.m-app .sp-pipeline-arrow {
  display: none;
}

html.m-app .sp-pipeline-stage {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: var(--m-1);
  width: 104px;
  min-height: 78px;
  padding: var(--m-3);
  border: 1px solid var(--m-hairline);
  border-radius: var(--m-r-sm);
  background: var(--m-surface-card);
}

html.m-app .sp-pipeline-stage:hover {
  transform: none;
}

html.m-app .sp-pipeline-icon {
  width: var(--m-icon);
  height: var(--m-icon);
  min-width: var(--m-icon);
  border-radius: 0;
  background: transparent;
}

html.m-app .sp-pipeline-icon svg { width: var(--m-icon-sm); height: var(--m-icon-sm); }

html.m-app .sp-pipeline-count {
  font-size: 1.25rem;
  font-weight: var(--m-fw-bold);
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
}

html.m-app .sp-pipeline-label {
  font-size: var(--m-fs-caption);
  font-weight: var(--m-fw-medium);
  text-align: left;
  line-height: 1.2;
}

/* Sparklines are decoration at this size — seven of them in a scrolling
   rail is noise, and each costs an SVG. */
html.m-app .sp-pipeline-stage .sp-spark {
  display: none;
}

/* ── Portal cards ───────────────────────────────────────────────────────── */
html.m-app :is(.sp-card, .sp-bal-card, .admin-card) {
  padding: var(--m-4);
  border-radius: var(--m-r);
  border: 1px solid var(--m-hairline);
  box-shadow: var(--m-shadow-sm);
  margin-bottom: var(--m-3);
}

html.m-app .sp-card-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--m-3);
  margin-bottom: var(--m-3);
}

html.m-app .sp-card-title {
  font-size: var(--m-fs-card-title);
  font-weight: var(--m-fw-semibold);
  letter-spacing: var(--m-track-title);
  margin: 0;
}

html.m-app .sp-link-btn {
  flex: 0 0 auto;
  min-height: var(--m-touch);
  padding: 0;
  font-size: var(--m-fs-secondary);
  font-weight: var(--m-fw-medium);
  color: var(--color-secondary-text);
  white-space: nowrap;
}

/* Balance row → a metric rail, same as every other group of figures. */
html.m-app .sp-balance-row {
  display: flex;
  flex-wrap: nowrap;
  gap: var(--m-2);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  margin: 0 calc(var(--m-gutter) * -1) var(--m-3);
  padding: var(--m-1) var(--m-gutter);
}

html.m-app .sp-balance-row::-webkit-scrollbar { display: none; }

html.m-app .sp-bal-card {
  flex: 0 0 auto;
  width: 148px;
  min-height: 88px;
  margin: 0;
  padding: var(--m-3);
}

html.m-app .sp-bal-icon {
  width: 28px;
  height: 28px;
  min-width: 28px;
  border-radius: var(--m-r-xs);
  margin-bottom: var(--m-1);
}

html.m-app .sp-bal-icon svg { width: var(--m-icon-sm); height: var(--m-icon-sm); }

html.m-app .sp-bal-label {
  font-size: var(--m-fs-caption);
  color: var(--color-text-secondary);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

html.m-app .sp-bal-val {
  font-size: var(--m-fs-card-title);
  font-weight: var(--m-fw-bold);
  font-variant-numeric: tabular-nums;
  margin: 0;
}

/* ── Portal stat cards ──────────────────────────────────────────────────── */
html.m-app .sp-stat-card {
  width: 148px;
  min-height: 84px;
  padding: var(--m-3);
}

html.m-app .sp-stat-body { display: contents; }

html.m-app .sp-stat-icon {
  width: var(--m-icon);
  height: var(--m-icon);
  min-width: var(--m-icon);
  border-radius: 0;
  background: transparent !important;
  margin-bottom: var(--m-1);
}

html.m-app .sp-stat-icon svg { width: var(--m-icon-sm); height: var(--m-icon-sm); }

html.m-app .sp-stat-label {
  order: -1;
  font-size: var(--m-fs-caption);
  color: var(--color-text-secondary);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

html.m-app .sp-stat-value {
  font-size: 1.25rem;
  font-weight: var(--m-fw-bold);
  line-height: 1.15;
  font-variant-numeric: tabular-nums;
  margin: 0;
}

html.m-app .sp-stat-sub {
  font-size: var(--m-fs-caption);
  color: var(--color-text-muted);
  margin: 0;
  white-space: nowrap;
}

/* ── Status tabs ────────────────────────────────────────────────────────
   A row of status filters that wrapped onto three lines becomes one
   scrolling rail of chips. */
html.m-app .sp-status-tabs {
  display: flex;
  flex-wrap: nowrap;
  gap: var(--m-2);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  margin: 0 calc(var(--m-gutter) * -1) var(--m-3);
  padding: 0 var(--m-gutter) var(--m-1);
}

html.m-app .sp-status-tabs::-webkit-scrollbar { display: none; }

html.m-app .sp-status-tabs > button {
  flex: 0 0 auto;
  min-height: 36px;
  padding: 0 var(--m-3);
  border-radius: var(--m-r-pill);
  font-size: var(--m-fs-secondary);
  font-weight: var(--m-fw-medium);
  white-space: nowrap;
}

/* ── Date range + granularity ───────────────────────────────────────────── */
html.m-app .sp-range-row,
html.m-app .sp-dash-head {
  flex-wrap: wrap;
  gap: var(--m-2);
}

html.m-app .sp-top-product-row {
  display: flex;
  align-items: center;
  gap: var(--m-3);
  min-height: 56px;
  padding: var(--m-2) 0;
  border-bottom: 1px solid var(--m-hairline);
}

html.m-app .sp-top-rank {
  width: 24px;
  height: 24px;
  min-width: 24px;
  font-size: var(--m-fs-caption);
  border-radius: var(--m-r-xs);
}

html.m-app .sp-top-name {
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-medium);
  line-height: var(--m-lh-snug);
}

html.m-app .sp-top-info {
  font-size: var(--m-fs-caption);
  color: var(--color-text-secondary);
}


/* ════════════════════════════════════════════════════════════════════════
   Sidebar → navigation drawer

   The portal's sidebar is a 240px column that collapses to a 56px icon rail
   (.sp-sidebar-collapsed) — two desktop states, neither of which works on a
   390px screen: the column takes 62% of the width, and the rail is a strip
   of unlabelled icons.

   On mobile the two states become "closed" and "drawer". The component's
   own \`sidebarOpen\` flag drives both, so the existing toggle button still
   works and no new state was introduced; it just defaults to closed on
   mobile (SellerPortal.js).

   The drawer starts *below* the app bar and the bar is lifted above it, so
   the toggle stays visible and tappable to dismiss — which is what lets the
   scrim be a box-shadow (there is no separate scrim element to click).
   ════════════════════════════════════════════════════════════════════════ */

html.m-app .sp-topbar {
  z-index: 220;
}

/* Collapsed: fully off-canvas rather than a 56px icon rail.

   Both class names are matched so this outranks the \`display: flex\` on
   .sp-sidebar below — they would otherwise tie on specificity and the
   later rule would win, leaving the drawer permanently open. */
html.m-app .sp-sidebar.sp-sidebar-collapsed {
  display: none;
}

html.m-app .sp-sidebar {
  /* SellerPortal.css hides the sidebar outright below 640px and puts nothing
     in its place, which leaves the portal with no navigation at all on a
     phone — the toggle button is there, but pressing it does nothing you can
     see. \`display\` has to be restated here, not just position: that rule is
     \`display: none\` and nothing in this layer was overriding that property. */
  display: flex;
  position: fixed;
  top: calc(var(--m-appbar) + var(--m-safe-top));
  left: 0;
  bottom: 0;
  z-index: 200;
  width: min(78vw, 300px);
  min-width: 0;
  padding-bottom: var(--m-safe-bottom);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  border-right: 1px solid var(--m-hairline);
  /* The scrim: an outward shadow large enough to cover the rest of the
     viewport, so the content behind the drawer dims without needing a
     separate overlay node. */
  box-shadow: 0 0 0 100vmax var(--color-overlay);
  animation: m-drawer-in var(--m-dur) var(--m-ease);
}

@keyframes m-drawer-in {
  from { transform: translateX(-100%); }
  to   { transform: translateX(0); }
}

@media (prefers-reduced-motion: reduce) {
  html.m-app .sp-sidebar { animation: none; }
}

html.m-app .sp-nav-btn {
  min-height: var(--m-touch);
  gap: var(--m-3);
  padding: var(--m-2) var(--m-4);
  border-radius: 0;
  font-size: var(--m-fs-body);
}

html.m-app .sp-nav-btn.active {
  font-weight: var(--m-fw-semibold);
}

html.m-app .sp-nav-label {
  font-size: var(--m-fs-body);
}

html.m-app .sp-nav-icon svg { width: var(--m-icon); height: var(--m-icon); }

html.m-app .sp-sidebar-seller {
  padding: var(--m-4);
  border-bottom: 1px solid var(--m-hairline);
}

html.m-app .sp-seller-name {
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-semibold);
  margin: 0;
}

html.m-app .sp-seller-role {
  font-size: var(--m-fs-caption);
  color: var(--color-text-secondary);
  margin: 0;
}

/* The toggle renders a ◀ / ▶ glyph, which reads as "collapse a column" —
   a desktop idea. The glyph is suppressed and a hamburger drawn in its
   place, so the control says "menu" the way a phone user expects. The
   button keeps its text for assistive technology. */
html.m-app .sp-toggle-sidebar {
  position: relative;
  width: var(--m-touch);
  height: var(--m-touch);
  min-width: var(--m-touch);
  min-height: var(--m-touch);
  padding: 0;
  border-radius: var(--m-r-pill);
  font-size: 0;
  color: var(--color-text-primary);
  flex: 0 0 auto;
}

html.m-app .sp-toggle-sidebar::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 18px;
  height: 2px;
  margin-left: -9px;
  border-radius: 2px;
  background: currentColor;
  box-shadow: 0 -6px 0 currentColor, 0 6px 0 currentColor;
}

html.m-app .sp-toggle-sidebar:active {
  background: var(--color-surface-hover);
}

/* ── Balance cards ──────────────────────────────────────────────────────
   The supporting line ("From completed orders") wrapped to two lines and
   doubled each card's height inside a rail where every card is as tall as
   the tallest. One line, clipped. */
html.m-app .sp-bal-sub,
html.m-app .sp-bal-card > p:last-child {
  font-size: var(--m-fs-caption);
  line-height: 1.3;
  color: var(--color-text-muted);
  margin: var(--m-1) 0 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

html.m-app .sp-bal-card hr,
html.m-app .sp-bal-card .sp-spark {
  display: none;
}


/* ── Table container ────────────────────────────────────────────────────
   Once each row is its own card, the .sp-card wrapping the table is a
   second border around a stack of borders. It flattens to a plain
   container so the cards sit directly on the page. */
html.m-app .sp-card:has(.sp-table),
html.m-app .sp-card:has(.sl-table) {
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

html.m-app .sp-table-wrap {
  overflow: visible;
}

/* Row actions share the footer evenly rather than huddling at the left. */
html.m-app .sp-table td[data-label=""]:last-child > * {
  flex: 1 1;
  min-width: 0;
}

/* ── Filters ────────────────────────────────────────────────────────────
   Search on its own line (it's the primary way to find a product), then
   the two selects side by side instead of two full-width rows stacked. */
html.m-app .sp-filters {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--m-2);
  margin-bottom: var(--m-3);
}

html.m-app .sp-search-wrap {
  grid-column: 1 / -1;
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--m-2);
  height: var(--m-touch);
  padding: 0 var(--m-3);
  border: 1px solid var(--m-hairline);
  border-radius: var(--m-r-pill);
  background: var(--m-surface-sunken);
}

html.m-app .sp-search-wrap:focus-within {
  border-color: var(--color-secondary);
  background: var(--m-surface-card);
}

html.m-app .sp-search-icon {
  position: static;
  flex: 0 0 auto;
  display: inline-flex;
  color: var(--color-text-muted);
}

html.m-app .sp-search {
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  padding: 0;
  border: none;
  background: transparent;
  font-size: 1rem;
}

html.m-app .sp-select-sm {
  width: 100%;
  min-width: 0;
  height: var(--m-touch);
  min-height: var(--m-touch);
  padding: 0 var(--m-6) 0 var(--m-3);
  border-radius: var(--m-r-sm);
  font-size: var(--m-fs-secondary);
}

/* ── Toolbar buttons ────────────────────────────────────────────────────
   Export CSV / Import CSV / + Add Product wrapped onto two ragged rows.
   The two CSV actions share a row as secondary controls; the primary
   action takes the full width beneath them. */
html.m-app .sp-toolbar-actions,
html.m-app .sp-page-head-right {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--m-2);
  width: 100%;
}

html.m-app :is(.sp-toolbar-actions, .sp-page-head-right) > * {
  min-height: var(--m-touch);
  font-size: var(--m-fs-secondary);
  white-space: nowrap;
}

/* The primary action is the one that creates something; it spans. */
html.m-app :is(.sp-toolbar-actions, .sp-page-head-right) > .sp-btn-primary,
html.m-app :is(.sp-toolbar-actions, .sp-page-head-right) > :last-child:nth-child(odd) {
  grid-column: 1 / -1;
}

/* ── Order cards ────────────────────────────────────────────────────────
   The portal already ships a card layout for orders (.sp-order-cards);
   it just needs mobile measure. */
html.m-app .sp-order-cards { gap: var(--m-3); }

html.m-app .sp-order-card {
  border-radius: var(--m-r);
  border-color: var(--m-hairline);
  box-shadow: var(--m-shadow-sm);
}

html.m-app .sp-order-card-head { padding: var(--m-3) var(--m-4) var(--m-2); }
html.m-app .sp-order-card-body { padding: var(--m-3) var(--m-4); gap: var(--m-1); }
html.m-app .sp-order-card-foot { padding: var(--m-3) var(--m-4); }
html.m-app .sp-order-id { font-size: var(--m-fs-body); font-weight: var(--m-fw-semibold); }
html.m-app .sp-order-info-row { font-size: var(--m-fs-secondary); }
html.m-app .sp-order-earning-cell { font-size: var(--m-fs-caption); padding: var(--m-2); }
`, "",{"version":3,"sources":["webpack://./src/mobile/portals.css"],"names":[],"mappings":"AAAA;;;;;;;;;6EAS6E;;AAE7E;;;sBAGsB;AACtB;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;EACrB,8BAA8B;EAC9B,gCAAgC;EAChC,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;EACjC,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;;;;gCAIgC;AAChC;EACE,2EAA2E;AAC7E;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,kCAAkC;EAClC,SAAS;AACX;;AAEA;mEACmE;AACnE;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAW;EACX,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;;;;;;;;0EAQ0E;AAC1E;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,6BAA6B;EAC7B,qBAAqB;EACrB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA,6CAA6C,aAAa,EAAE;;AAE5D;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;EACnC,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,mCAAmC,uBAAuB,EAAE,wBAAwB,EAAE;;AAEtF;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;0CAC0C;AAC1C;EACE,aAAa;AACf;;AAEA,8EAA8E;AAC9E;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mCAAmC;EACnC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,oCAAoC;EACpC,SAAS;AACX;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,UAAU;EACV,gCAAgC;EAChC,+BAA+B;EAC/B,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,+CAA+C;EAC/C,mCAAmC;AACrC;;AAEA,gDAAgD,aAAa,EAAE;;AAE/D;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,8BAA8B,uBAAuB,EAAE,wBAAwB,EAAE;;AAEjF;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,kCAAkC;EAClC,SAAS;AACX;;AAEA,8EAA8E;AAC9E;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,2BAA2B,iBAAiB,EAAE;;AAE9C;EACE,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA,+BAA+B,uBAAuB,EAAE,wBAAwB,EAAE;;AAElF;EACE,SAAS;EACT,8BAA8B;EAC9B,kCAAkC;EAClC,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;;6BAE6B;AAC7B;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,+CAA+C;EAC/C,qCAAqC;AACvC;;AAEA,gDAAgD,aAAa,EAAE;;AAE/D;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;EAC9B,gCAAgC;EAChC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,8EAA8E;AAC9E;;EAEE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;;AAGA;;;;;;;;;;;;;;;;6EAgB6E;;AAE7E;EACE,YAAY;AACd;;AAEA;;;;+DAI+D;AAC/D;EACE,aAAa;AACf;;AAEA;EACE;;;;8EAI4E;EAC5E,aAAa;EACb,eAAe;EACf,8CAA8C;EAC9C,OAAO;EACP,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,iCAAiC;EACjC,4BAA4B;EAC5B,yCAAyC;EACzC;;6BAE2B;EAC3B,8CAA8C;EAC9C,iDAAiD;AACnD;;AAEA;EACE,OAAO,4BAA4B,EAAE;EACrC,OAAO,wBAAwB,EAAE;AACnC;;AAEA;EACE,yBAAyB,eAAe,EAAE;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,8BAA8B,oBAAoB,EAAE,qBAAqB,EAAE;;AAE3E;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,SAAS;AACX;;AAEA;;;oDAGoD;AACpD;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,UAAU;EACV,8BAA8B;EAC9B,YAAY;EACZ,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,uDAAuD;AACzD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;;oCAGoC;AACpC;;EAEE,8BAA8B;EAC9B,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;;AAGA;;;qDAGqD;AACrD;;EAEE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,0EAA0E;AAC1E;EACE,SAAW;EACX,YAAY;AACd;;AAEA;;yEAEyE;AACzE;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,qBAAqB;EACrB,mCAAmC;EACnC,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;EAC1B,kCAAkC;EAClC,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;;;8CAG8C;AAC9C;;EAEE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,oEAAoE;AACpE;;EAEE,mBAAmB;AACrB;;AAEA;;kCAEkC;AAClC,6BAA6B,eAAe,EAAE;;AAE9C;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA,iCAAiC,yCAAyC,EAAE;AAC5E,iCAAiC,8BAA8B,EAAE,eAAe,EAAE;AAClF,iCAAiC,8BAA8B,EAAE;AACjE,0BAA0B,2BAA2B,EAAE,iCAAiC,EAAE;AAC1F,gCAAgC,gCAAgC,EAAE;AAClE,oCAAoC,8BAA8B,EAAE,mBAAmB,EAAE","sourcesContent":["/* ════════════════════════════════════════════════════════════════════════\n   Seller and admin portals\n\n   These are the two surfaces built most explicitly for a desktop: a\n   persistent left sidebar of 14 nav items, page heads that put a title and\n   two buttons on one line, and analytics laid out for a 1400px canvas.\n\n   The data and every action are kept. What changes is that the portal stops\n   pretending it has a second column and a wide viewport.\n   ════════════════════════════════════════════════════════════════════════ */\n\n/* ── Portal app bar ─────────────────────────────────────────────────────\n   .sp-topbar is the portal's own header. It gets the same geometry as the\n   storefront's app bar so moving between the two doesn't feel like moving\n   between two apps. */\nhtml.m-app .sp-topbar {\n  position: sticky;\n  top: 0;\n  z-index: 120;\n  gap: var(--m-1);\n  min-height: var(--m-appbar);\n  padding: 0 var(--m-2);\n  padding-top: var(--m-safe-top);\n  background: var(--m-surface-bar);\n  border-bottom: 1px solid var(--m-hairline);\n  box-shadow: none;\n}\n\nhtml.m-app .sp-topbar-title {\n  font-size: 1.0625rem;\n  font-weight: var(--m-fw-semibold);\n  letter-spacing: var(--m-track-title);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\nhtml.m-app .sp-topbar-right {\n  gap: 0;\n}\n\nhtml.m-app .sp-topbar button {\n  min-width: var(--m-touch);\n  min-height: var(--m-touch);\n  border-radius: var(--m-r-pill);\n}\n\n/* ── Page head ──────────────────────────────────────────────────────────\n   The app bar already names the screen, so the page title repeating it\n   (\"Dashboard\" twice, one above the other) is pure duplication. The title\n   goes; the subtitle stays, since \"Welcome back, <name>\" is the only place\n   the portal greets its user. */\nhtml.m-app .sp-page {\n  padding: var(--m-4) var(--m-gutter) calc(var(--m-8) + var(--m-safe-bottom));\n}\n\nhtml.m-app .sp-page-head {\n  flex-direction: column;\n  align-items: stretch;\n  gap: var(--m-3);\n  margin-bottom: var(--m-4);\n}\n\nhtml.m-app .sp-page-title {\n  display: none;\n}\n\nhtml.m-app .sp-page-sub {\n  font-size: var(--m-fs-secondary);\n  line-height: var(--m-lh-snug);\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n/* Head actions: one primary, the rest secondary. \"Export\" and \"+ Add\n   Product\" were two filled buttons of equal weight side by side. */\nhtml.m-app .sp-page-head-right {\n  display: flex;\n  gap: var(--m-2);\n  width: 100%;\n}\n\nhtml.m-app .sp-page-head-right > * {\n  flex: 1 1 0;\n  min-height: var(--m-touch);\n  font-size: var(--m-fs-secondary);\n  white-space: nowrap;\n}\n\n/* ── Order pipeline ─────────────────────────────────────────────────────\n   Seven stages, each a 170px-tall card with a 40px icon disc and a\n   sparkline, wrapped into a 2-column grid — about three screens of\n   scrolling for seven numbers. It becomes one swipeable rail of compact\n   stages, which is also closer to what a pipeline *is*: an ordered\n   sequence you read left to right.\n\n   The connecting \"›\" arrows are dropped: with the stages scrolling they\n   no longer line up, and the horizontal order already implies the flow. */\nhtml.m-app .sp-pipeline {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: var(--m-2);\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scroll-snap-type: x proximity;\n  scrollbar-width: none;\n  margin: 0 calc(var(--m-4) * -1);\n  padding: var(--m-1) var(--m-4);\n}\n\nhtml.m-app .sp-pipeline::-webkit-scrollbar { display: none; }\n\nhtml.m-app .sp-pipeline-step {\n  flex: 0 0 auto;\n  scroll-snap-align: start;\n}\n\nhtml.m-app .sp-pipeline-arrow {\n  display: none;\n}\n\nhtml.m-app .sp-pipeline-stage {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: var(--m-1);\n  width: 104px;\n  min-height: 78px;\n  padding: var(--m-3);\n  border: 1px solid var(--m-hairline);\n  border-radius: var(--m-r-sm);\n  background: var(--m-surface-card);\n}\n\nhtml.m-app .sp-pipeline-stage:hover {\n  transform: none;\n}\n\nhtml.m-app .sp-pipeline-icon {\n  width: var(--m-icon);\n  height: var(--m-icon);\n  min-width: var(--m-icon);\n  border-radius: 0;\n  background: transparent;\n}\n\nhtml.m-app .sp-pipeline-icon svg { width: var(--m-icon-sm); height: var(--m-icon-sm); }\n\nhtml.m-app .sp-pipeline-count {\n  font-size: 1.25rem;\n  font-weight: var(--m-fw-bold);\n  line-height: 1.1;\n  font-variant-numeric: tabular-nums;\n}\n\nhtml.m-app .sp-pipeline-label {\n  font-size: var(--m-fs-caption);\n  font-weight: var(--m-fw-medium);\n  text-align: left;\n  line-height: 1.2;\n}\n\n/* Sparklines are decoration at this size — seven of them in a scrolling\n   rail is noise, and each costs an SVG. */\nhtml.m-app .sp-pipeline-stage .sp-spark {\n  display: none;\n}\n\n/* ── Portal cards ───────────────────────────────────────────────────────── */\nhtml.m-app :is(.sp-card, .sp-bal-card, .admin-card) {\n  padding: var(--m-4);\n  border-radius: var(--m-r);\n  border: 1px solid var(--m-hairline);\n  box-shadow: var(--m-shadow-sm);\n  margin-bottom: var(--m-3);\n}\n\nhtml.m-app .sp-card-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: var(--m-3);\n  margin-bottom: var(--m-3);\n}\n\nhtml.m-app .sp-card-title {\n  font-size: var(--m-fs-card-title);\n  font-weight: var(--m-fw-semibold);\n  letter-spacing: var(--m-track-title);\n  margin: 0;\n}\n\nhtml.m-app .sp-link-btn {\n  flex: 0 0 auto;\n  min-height: var(--m-touch);\n  padding: 0;\n  font-size: var(--m-fs-secondary);\n  font-weight: var(--m-fw-medium);\n  color: var(--color-secondary-text);\n  white-space: nowrap;\n}\n\n/* Balance row → a metric rail, same as every other group of figures. */\nhtml.m-app .sp-balance-row {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: var(--m-2);\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  margin: 0 calc(var(--m-gutter) * -1) var(--m-3);\n  padding: var(--m-1) var(--m-gutter);\n}\n\nhtml.m-app .sp-balance-row::-webkit-scrollbar { display: none; }\n\nhtml.m-app .sp-bal-card {\n  flex: 0 0 auto;\n  width: 148px;\n  min-height: 88px;\n  margin: 0;\n  padding: var(--m-3);\n}\n\nhtml.m-app .sp-bal-icon {\n  width: 28px;\n  height: 28px;\n  min-width: 28px;\n  border-radius: var(--m-r-xs);\n  margin-bottom: var(--m-1);\n}\n\nhtml.m-app .sp-bal-icon svg { width: var(--m-icon-sm); height: var(--m-icon-sm); }\n\nhtml.m-app .sp-bal-label {\n  font-size: var(--m-fs-caption);\n  color: var(--color-text-secondary);\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\nhtml.m-app .sp-bal-val {\n  font-size: var(--m-fs-card-title);\n  font-weight: var(--m-fw-bold);\n  font-variant-numeric: tabular-nums;\n  margin: 0;\n}\n\n/* ── Portal stat cards ──────────────────────────────────────────────────── */\nhtml.m-app .sp-stat-card {\n  width: 148px;\n  min-height: 84px;\n  padding: var(--m-3);\n}\n\nhtml.m-app .sp-stat-body { display: contents; }\n\nhtml.m-app .sp-stat-icon {\n  width: var(--m-icon);\n  height: var(--m-icon);\n  min-width: var(--m-icon);\n  border-radius: 0;\n  background: transparent !important;\n  margin-bottom: var(--m-1);\n}\n\nhtml.m-app .sp-stat-icon svg { width: var(--m-icon-sm); height: var(--m-icon-sm); }\n\nhtml.m-app .sp-stat-label {\n  order: -1;\n  font-size: var(--m-fs-caption);\n  color: var(--color-text-secondary);\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\nhtml.m-app .sp-stat-value {\n  font-size: 1.25rem;\n  font-weight: var(--m-fw-bold);\n  line-height: 1.15;\n  font-variant-numeric: tabular-nums;\n  margin: 0;\n}\n\nhtml.m-app .sp-stat-sub {\n  font-size: var(--m-fs-caption);\n  color: var(--color-text-muted);\n  margin: 0;\n  white-space: nowrap;\n}\n\n/* ── Status tabs ────────────────────────────────────────────────────────\n   A row of status filters that wrapped onto three lines becomes one\n   scrolling rail of chips. */\nhtml.m-app .sp-status-tabs {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: var(--m-2);\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  margin: 0 calc(var(--m-gutter) * -1) var(--m-3);\n  padding: 0 var(--m-gutter) var(--m-1);\n}\n\nhtml.m-app .sp-status-tabs::-webkit-scrollbar { display: none; }\n\nhtml.m-app .sp-status-tabs > button {\n  flex: 0 0 auto;\n  min-height: 36px;\n  padding: 0 var(--m-3);\n  border-radius: var(--m-r-pill);\n  font-size: var(--m-fs-secondary);\n  font-weight: var(--m-fw-medium);\n  white-space: nowrap;\n}\n\n/* ── Date range + granularity ───────────────────────────────────────────── */\nhtml.m-app .sp-range-row,\nhtml.m-app .sp-dash-head {\n  flex-wrap: wrap;\n  gap: var(--m-2);\n}\n\nhtml.m-app .sp-top-product-row {\n  display: flex;\n  align-items: center;\n  gap: var(--m-3);\n  min-height: 56px;\n  padding: var(--m-2) 0;\n  border-bottom: 1px solid var(--m-hairline);\n}\n\nhtml.m-app .sp-top-rank {\n  width: 24px;\n  height: 24px;\n  min-width: 24px;\n  font-size: var(--m-fs-caption);\n  border-radius: var(--m-r-xs);\n}\n\nhtml.m-app .sp-top-name {\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-medium);\n  line-height: var(--m-lh-snug);\n}\n\nhtml.m-app .sp-top-info {\n  font-size: var(--m-fs-caption);\n  color: var(--color-text-secondary);\n}\n\n\n/* ════════════════════════════════════════════════════════════════════════\n   Sidebar → navigation drawer\n\n   The portal's sidebar is a 240px column that collapses to a 56px icon rail\n   (.sp-sidebar-collapsed) — two desktop states, neither of which works on a\n   390px screen: the column takes 62% of the width, and the rail is a strip\n   of unlabelled icons.\n\n   On mobile the two states become \"closed\" and \"drawer\". The component's\n   own `sidebarOpen` flag drives both, so the existing toggle button still\n   works and no new state was introduced; it just defaults to closed on\n   mobile (SellerPortal.js).\n\n   The drawer starts *below* the app bar and the bar is lifted above it, so\n   the toggle stays visible and tappable to dismiss — which is what lets the\n   scrim be a box-shadow (there is no separate scrim element to click).\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app .sp-topbar {\n  z-index: 220;\n}\n\n/* Collapsed: fully off-canvas rather than a 56px icon rail.\n\n   Both class names are matched so this outranks the `display: flex` on\n   .sp-sidebar below — they would otherwise tie on specificity and the\n   later rule would win, leaving the drawer permanently open. */\nhtml.m-app .sp-sidebar.sp-sidebar-collapsed {\n  display: none;\n}\n\nhtml.m-app .sp-sidebar {\n  /* SellerPortal.css hides the sidebar outright below 640px and puts nothing\n     in its place, which leaves the portal with no navigation at all on a\n     phone — the toggle button is there, but pressing it does nothing you can\n     see. `display` has to be restated here, not just position: that rule is\n     `display: none` and nothing in this layer was overriding that property. */\n  display: flex;\n  position: fixed;\n  top: calc(var(--m-appbar) + var(--m-safe-top));\n  left: 0;\n  bottom: 0;\n  z-index: 200;\n  width: min(78vw, 300px);\n  min-width: 0;\n  padding-bottom: var(--m-safe-bottom);\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n  border-right: 1px solid var(--m-hairline);\n  /* The scrim: an outward shadow large enough to cover the rest of the\n     viewport, so the content behind the drawer dims without needing a\n     separate overlay node. */\n  box-shadow: 0 0 0 100vmax var(--color-overlay);\n  animation: m-drawer-in var(--m-dur) var(--m-ease);\n}\n\n@keyframes m-drawer-in {\n  from { transform: translateX(-100%); }\n  to   { transform: translateX(0); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html.m-app .sp-sidebar { animation: none; }\n}\n\nhtml.m-app .sp-nav-btn {\n  min-height: var(--m-touch);\n  gap: var(--m-3);\n  padding: var(--m-2) var(--m-4);\n  border-radius: 0;\n  font-size: var(--m-fs-body);\n}\n\nhtml.m-app .sp-nav-btn.active {\n  font-weight: var(--m-fw-semibold);\n}\n\nhtml.m-app .sp-nav-label {\n  font-size: var(--m-fs-body);\n}\n\nhtml.m-app .sp-nav-icon svg { width: var(--m-icon); height: var(--m-icon); }\n\nhtml.m-app .sp-sidebar-seller {\n  padding: var(--m-4);\n  border-bottom: 1px solid var(--m-hairline);\n}\n\nhtml.m-app .sp-seller-name {\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-semibold);\n  margin: 0;\n}\n\nhtml.m-app .sp-seller-role {\n  font-size: var(--m-fs-caption);\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n/* The toggle renders a ◀ / ▶ glyph, which reads as \"collapse a column\" —\n   a desktop idea. The glyph is suppressed and a hamburger drawn in its\n   place, so the control says \"menu\" the way a phone user expects. The\n   button keeps its text for assistive technology. */\nhtml.m-app .sp-toggle-sidebar {\n  position: relative;\n  width: var(--m-touch);\n  height: var(--m-touch);\n  min-width: var(--m-touch);\n  min-height: var(--m-touch);\n  padding: 0;\n  border-radius: var(--m-r-pill);\n  font-size: 0;\n  color: var(--color-text-primary);\n  flex: 0 0 auto;\n}\n\nhtml.m-app .sp-toggle-sidebar::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 18px;\n  height: 2px;\n  margin-left: -9px;\n  border-radius: 2px;\n  background: currentColor;\n  box-shadow: 0 -6px 0 currentColor, 0 6px 0 currentColor;\n}\n\nhtml.m-app .sp-toggle-sidebar:active {\n  background: var(--color-surface-hover);\n}\n\n/* ── Balance cards ──────────────────────────────────────────────────────\n   The supporting line (\"From completed orders\") wrapped to two lines and\n   doubled each card's height inside a rail where every card is as tall as\n   the tallest. One line, clipped. */\nhtml.m-app .sp-bal-sub,\nhtml.m-app .sp-bal-card > p:last-child {\n  font-size: var(--m-fs-caption);\n  line-height: 1.3;\n  color: var(--color-text-muted);\n  margin: var(--m-1) 0 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\nhtml.m-app .sp-bal-card hr,\nhtml.m-app .sp-bal-card .sp-spark {\n  display: none;\n}\n\n\n/* ── Table container ────────────────────────────────────────────────────\n   Once each row is its own card, the .sp-card wrapping the table is a\n   second border around a stack of borders. It flattens to a plain\n   container so the cards sit directly on the page. */\nhtml.m-app .sp-card:has(.sp-table),\nhtml.m-app .sp-card:has(.sl-table) {\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n}\n\nhtml.m-app .sp-table-wrap {\n  overflow: visible;\n}\n\n/* Row actions share the footer evenly rather than huddling at the left. */\nhtml.m-app .sp-table td[data-label=\"\"]:last-child > * {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n/* ── Filters ────────────────────────────────────────────────────────────\n   Search on its own line (it's the primary way to find a product), then\n   the two selects side by side instead of two full-width rows stacked. */\nhtml.m-app .sp-filters {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--m-2);\n  margin-bottom: var(--m-3);\n}\n\nhtml.m-app .sp-search-wrap {\n  grid-column: 1 / -1;\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: var(--m-2);\n  height: var(--m-touch);\n  padding: 0 var(--m-3);\n  border: 1px solid var(--m-hairline);\n  border-radius: var(--m-r-pill);\n  background: var(--m-surface-sunken);\n}\n\nhtml.m-app .sp-search-wrap:focus-within {\n  border-color: var(--color-secondary);\n  background: var(--m-surface-card);\n}\n\nhtml.m-app .sp-search-icon {\n  position: static;\n  flex: 0 0 auto;\n  display: inline-flex;\n  color: var(--color-text-muted);\n}\n\nhtml.m-app .sp-search {\n  flex: 1 1 auto;\n  min-width: 0;\n  height: 100%;\n  padding: 0;\n  border: none;\n  background: transparent;\n  font-size: 1rem;\n}\n\nhtml.m-app .sp-select-sm {\n  width: 100%;\n  min-width: 0;\n  height: var(--m-touch);\n  min-height: var(--m-touch);\n  padding: 0 var(--m-6) 0 var(--m-3);\n  border-radius: var(--m-r-sm);\n  font-size: var(--m-fs-secondary);\n}\n\n/* ── Toolbar buttons ────────────────────────────────────────────────────\n   Export CSV / Import CSV / + Add Product wrapped onto two ragged rows.\n   The two CSV actions share a row as secondary controls; the primary\n   action takes the full width beneath them. */\nhtml.m-app .sp-toolbar-actions,\nhtml.m-app .sp-page-head-right {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--m-2);\n  width: 100%;\n}\n\nhtml.m-app :is(.sp-toolbar-actions, .sp-page-head-right) > * {\n  min-height: var(--m-touch);\n  font-size: var(--m-fs-secondary);\n  white-space: nowrap;\n}\n\n/* The primary action is the one that creates something; it spans. */\nhtml.m-app :is(.sp-toolbar-actions, .sp-page-head-right) > .sp-btn-primary,\nhtml.m-app :is(.sp-toolbar-actions, .sp-page-head-right) > :last-child:nth-child(odd) {\n  grid-column: 1 / -1;\n}\n\n/* ── Order cards ────────────────────────────────────────────────────────\n   The portal already ships a card layout for orders (.sp-order-cards);\n   it just needs mobile measure. */\nhtml.m-app .sp-order-cards { gap: var(--m-3); }\n\nhtml.m-app .sp-order-card {\n  border-radius: var(--m-r);\n  border-color: var(--m-hairline);\n  box-shadow: var(--m-shadow-sm);\n}\n\nhtml.m-app .sp-order-card-head { padding: var(--m-3) var(--m-4) var(--m-2); }\nhtml.m-app .sp-order-card-body { padding: var(--m-3) var(--m-4); gap: var(--m-1); }\nhtml.m-app .sp-order-card-foot { padding: var(--m-3) var(--m-4); }\nhtml.m-app .sp-order-id { font-size: var(--m-fs-body); font-weight: var(--m-fw-semibold); }\nhtml.m-app .sp-order-info-row { font-size: var(--m-fs-secondary); }\nhtml.m-app .sp-order-earning-cell { font-size: var(--m-fs-caption); padding: var(--m-2); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
